import type { MorrisonsPayload, MorrisonsWeek } from './report';

/** Stickers scanned = new cards + duplicate scans; null while duplicates are unknown (no app events). */
export const stickersTotal = (t: MorrisonsPayload['totals']) => (t.duplicateScans == null ? null : t.newCards + t.duplicateScans);

/** A week's stickers scanned: new cards plus duplicates (new cards alone while the app events are missing); null for a week to come. */
export const weekStickers = (w: MorrisonsWeek) => (w.newCards == null ? null : w.newCards + (w.duplicateScans ?? 0));

/** The five rarest cards (fewest collected), once any card has been collected. */
export const rarestCards = (cards: MorrisonsPayload['cards']) =>
  cards.some((c) => c.collected > 0) ? [...cards].sort((a, b) => a.collected - b.collected || a.card.localeCompare(b.card)).slice(0, 5) : [];
